import { LOCALES } from "utils/constants";

const translation = {
  [LOCALES.FA]: {
    BREADCRUMB: [{ title: "نقشه" }],
    TITLE: "نقشه",
  },
  [LOCALES.EN]: {
    BREADCRUMB: [{ title: "Map" }],
    TITLE: "Map",
  },
} as const;

export default translation;
